import { Link } from "react-router-dom";
import { Code2 } from "lucide-react";

export function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-300 mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid grid-cols-1 md:grid-cols-4 gap-8">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-3">
            <span className="grid place-items-center h-9 w-9 rounded-lg bg-indigo-600 text-white"><Code2 className="h-5 w-5" /></span>
            <span className="font-heading font-extrabold text-lg text-white">DS <span className="text-indigo-400">KODE</span></span>
          </div>
          <p className="text-sm text-slate-400 max-w-sm leading-relaxed">
            Marketplace digital terpercaya untuk aplikasi, template, script, dan source code berkualitas bagi developer, bisnis, dan kreator digital.
          </p>
        </div>
        <div>
          <h4 className="font-heading font-semibold text-white mb-3 text-sm">Jelajahi</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/products" className="hover:text-indigo-400">Katalog Produk</Link></li>
            <li><Link to="/categories" className="hover:text-indigo-400">Kategori</Link></li>
            <li><Link to="/about" className="hover:text-indigo-400">Tentang Kami</Link></li>
            <li><Link to="/contact" className="hover:text-indigo-400">Kontak</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-heading font-semibold text-white mb-3 text-sm">Akun</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/login" className="hover:text-indigo-400">Masuk</Link></li>
            <li><Link to="/register" className="hover:text-indigo-400">Daftar Member</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-800 py-5 text-center text-xs text-slate-500">
        © {new Date().getFullYear()} DS KODE. Semua hak dilindungi.
      </div>
    </footer>
  );
}
